import { locales } from "@hubrise/react-components"
import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationEn from "shared/locales/en.json"
import translationFr from "shared/locales/fr.json"

export const resources = {
  en: { translation: { ...locales.en, ...translationEn } },
  fr: { translation: { ...locales.fr, ...translationFr } },
} as const

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    returnNull: false,
    interpolation: {
      escapeValue: false, // Not needed for React as it escapes by default
    },
  })

export default i18next
